import React, { Component } from 'react';

let data = "";
export class Modal1 extends Component {
    static displayName = Modal1.name;

    componentDidMount() {

        var reader = new FileReader();

        fetch('ppolicy.txt')
            .then(res => res.blob()) // Gets the response and returns it as a blob
            .then(blob => {

                reader.onload = function () {
                    var text = reader.result;
                    data = text;
                  //  console.log(data);

                };

                // Here, I use it to make an image appear on the page
                reader.readAsText(blob);

            });        
    }


    render() {

        const showproject = this.props.show;
        return (
            <div className={showproject ? "portfolio-modal modal fade show" : "portfolio-modal modal fade"} style={showproject ? { paddingRight: '17px', display: 'block' } : null} id="portfolioModal1" tabIndex="-1" role="dialog" aria-modal="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="close-modal" data-dismiss="modal" onClick={this.props.handleClose}>
                            <div className="lr">
                                <div className="rl"></div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8 mx-auto">
                                    <div className="modal-body">
                                        {/* Details Go Here */}
                                        <h2 className="text-uppercase">Privacy Policy</h2>
                                        <div dangerouslySetInnerHTML={{ __html: data }} />
                                        <button className="btn btn-contact" data-dismiss="modal" type="button" onClick={this.props.handleClose}>
                                            <i className="fas fa-times"></i>&nbsp;
                                            I Understand</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Modal1.js